import { render, staticRenderFns } from "./TotalDetails.vue?vue&type=template&id=6ef626e4&scoped=true"
import script from "./TotalDetails.vue?vue&type=script&lang=js"
export * from "./TotalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef626e4",
  null
  
)

export default component.exports